import React from "react";
type SectionIntroProps = {
  eyebrow: string;
  title: React.ReactNode;
  body?: string;
  light?: boolean;
  className?: string;
};
export function SectionIntro({
  eyebrow,
  title,
  body,
  light = false,
  className = ""
}: SectionIntroProps) {
  return <div className={className} data-id="element-238" data-mp="8mf4hslypu54">
      <div className="flex items-center gap-3" data-id="element-239" data-mp="dncjjwboe82e">
        <span className="h-px w-10 bg-bronze" aria-hidden="true" data-id="element-240" data-mp="dm1g5xm572bt" />
        <p className={`text-[10px] font-bold uppercase tracking-[0.22em] ${light ? "text-sand" : "text-bronze"}`} data-id="element-241" data-mp="3vszcfedz42or">{eyebrow}</p>
      </div>
      <h2 className={`mt-6 font-display text-5xl font-semibold uppercase leading-[0.88] tracking-[-0.045em] sm:text-6xl lg:text-8xl ${light ? "text-cream" : "text-ink"}`} data-id="element-242" data-mp="3qritn6ovj4d">{title}</h2>
      {body ? <p className={`mt-7 max-w-xl text-base leading-8 ${light ? "text-cream/65" : "text-ink/65"}`} data-id="element-243" data-mp="3quo272jrnq60">{body}</p> : null}
    </div>;
}